module.exports = __webpack_public_path__ + "media/event-access/conference@2x-f8be4def.png";